"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartSettingsStorage = exports.chartSettings = void 0;
exports.mountChartSettingsWhenReady = mountChartSettingsWhenReady;
exports.startChartCommentOverlay = startChartCommentOverlay;
const chart_metrics_1 = require("./chart-metrics");
const chart_comments_1 = require("./chart-comments");
const chart_settings_1 = require("./chart-settings");
const chart_screenshot_1 = require("./chart-screenshot");
const chart_screenshot_panel_1 = require("./chart-screenshot-panel");
const channelMessagesWindow = window;
const channelMessages = channelMessagesWindow.arzChannelMessages || (channelMessagesWindow.arzChannelMessages = (0, chart_comments_1.createChannelMessagesCoordinator)({
    fetchMessages: (channelId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        let user = false;
        try {
            user = yield ((_b = (_a = window.account) === null || _a === void 0 ? void 0 : _a.checkUserLogin) === null || _b === void 0 ? void 0 : _b.call(_a));
        }
        catch (_error) {
            user = false;
        }
        const authHeaders = user ? (window.account.headerToken() || {}) : {};
        const request = (0, chart_comments_1.createChannelMessagesRequest)(arzConstants.NEXUS_CHAT_BASEURL, channelId, Boolean(user), authHeaders);
        const response = yield fetch(request.url, {
            credentials: 'omit',
            headers: request.headers,
        });
        if (!response.ok)
            throw new Error(`Channel messages request failed: ${response.status}`);
        return response.json();
    }),
}));
const isMobileChart = (0, chart_settings_1.isMobileChartRequest)(window.location.search);
exports.chartSettings = (0, chart_settings_1.createChartSettingsStore)((0, chart_settings_1.getChartSettingsStorage)(window), {
    isMobile: isMobileChart,
    isStable: () => typeof coin_info !== 'undefined' && coin_info.is_stable === true,
});
exports.chartSettingsStorage = (0, chart_settings_1.getChartSettingsStorage)(window);
const widgetShare = (0, chart_screenshot_1.createWidgetShareLoader)(document, window);
// Sits beside the settings trigger inside the same control, so it shares its placement and loading state.
// share.js is requested on intent (hovering the controls, a touch on the chart or focus), never during page load.
function createChartScreenshotButton(chartBox, trigger, getState, onClick) {
    var _a;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'arz-chart-screenshot';
    button.setAttribute('aria-label', 'تصویر نمودار');
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = '<span class="arz-chart-screenshot__icon" aria-hidden="true"></span>';
    trigger.before(button);
    // Intent only: hovering the controls (a cursor resting over the chart while it renders
    // must not count), a real touch on the chart, or keyboard focus.
    const warm = () => { widgetShare.load().catch(() => { }); };
    (_a = trigger.parentElement) === null || _a === void 0 ? void 0 : _a.addEventListener('pointerenter', warm, { once: true, passive: true });
    chartBox.addEventListener('touchstart', warm, { once: true, passive: true });
    button.addEventListener('focus', warm, { once: true });
    // A render still in progress is reopened rather than requested again.
    let pending = null;
    button.addEventListener('click', () => {
        onClick();
        if (pending) {
            (0, chart_screenshot_panel_1.openChartScreenshotPanel)(pending);
            return;
        }
        const state = getState();
        const options = (0, chart_screenshot_1.getChartScreenshotOptions)(state);
        if (!options)
            return;
        button.setAttribute('aria-busy', 'true');
        // One render per click; the panel then offers the OS share sheet and saving, each on its own tap.
        const blob = widgetShare.load().then((widget) => (0, chart_screenshot_1.fetchChartScreenshot)(window.fetch.bind(window), widget.screenshotUrl(options)));
        const request = {
            blob,
            // Desktop also copies (started inside the click); mobile relies on the share sheet.
            copied: state.isMobile ? Promise.resolve(false) : (0, chart_screenshot_1.copyImageToClipboard)(window, blob),
            fileName: (0, chart_screenshot_1.getChartScreenshotFileName)(state, options),
            title: (0, chart_screenshot_1.getChartScreenshotTitle)(state),
            aspectRatio: options.aspectRatio,
            retry: () => button.click(),
            returnFocus: button,
        };
        pending = request;
        const idle = () => {
            if (pending === request)
                pending = null;
            button.removeAttribute('aria-busy');
        };
        blob.then(idle, idle);
        (0, chart_screenshot_panel_1.openChartScreenshotPanel)(request);
    });
    return button;
}
function createChartSettingsControl(chartElement, options) {
    var _a, _b;
    const chartBox = chartElement.closest('.arz-chart-loading-box');
    if (!chartBox || chartBox.querySelector('.arz-chart-settings'))
        return;
    const initialRangeButtons = chartElement.querySelectorAll('.highcharts-range-selector-group .highcharts-button');
    if (!(0, chart_settings_1.isChartSettingsReady)(Boolean(chartElement.querySelector('.highcharts-container')), initialRangeButtons.length))
        return;
    const control = document.createElement('div');
    control.className = 'arz-chart-settings';
    const popupId = `arz-chart-settings-popup-${chartElement.id}`;
    control.innerHTML = `
    <button class="arz-chart-settings__trigger" type="button" aria-label="تنظیمات نمودار" aria-controls="${popupId}" aria-expanded="false">
      <span class="arz-chart-settings__icon" aria-hidden="true"></span>
    </button>
    <div class="arz-chart-settings__popup" id="${popupId}" role="group" aria-label="تنظیمات نمودار" hidden>
      <label class="arz-chart-settings__option">
        <span>به روزرسانی زنده قیمت</span>
        <input type="checkbox" data-chart-setting="livePrice">
        <span class="arz-chart-settings__switch" aria-hidden="true"></span>
      </label>
      <label class="arz-chart-settings__option">
        <span>نمایش دیدگاه‌ها روی نمودار</span>
        <input type="checkbox" data-chart-setting="comments">
        <span class="arz-chart-settings__switch" aria-hidden="true"></span>
      </label>
      <label class="arz-chart-settings__option">
        <span>نمایش لگاریتمی</span>
        <input type="checkbox" data-chart-setting="logarithmic">
        <span class="arz-chart-settings__switch" aria-hidden="true"></span>
      </label>
      <fieldset class="arz-chart-settings__currency">
        <legend>مقدار پیش‌فرض نمودار</legend>
        <div class="arz-chart-settings__segments">
          <label>
            <input type="radio" name="${popupId}-currency" value="irt" ${options.currency === 'irt' ? 'checked' : ''}>
            <span>تومانی</span>
          </label>
          <label>
            <input type="radio" name="${popupId}-currency" value="usd" ${options.currency === 'usd' ? 'checked' : ''}>
            <span>دلاری</span>
          </label>
        </div>
      </fieldset>
    </div>`;
    chartBox.appendChild(control);
    const trigger = control.querySelector('.arz-chart-settings__trigger');
    const popup = control.querySelector('.arz-chart-settings__popup');
    const inputs = Array.from(control.querySelectorAll('[data-chart-setting]'));
    const currencyInputs = Array.from(control.querySelectorAll('.arz-chart-settings__currency input[type="radio"]'));
    let activeMetric = 'price';
    const screenshotButton = options.screenshot
        ? createChartScreenshotButton(chartBox, trigger, options.screenshot, () => closePopup())
        : null;
    if (options.onMetricChange) {
        control.classList.add('arz-chart-settings--metrics');
        const settingsPanel = document.createElement('div');
        settingsPanel.id = `${popupId}-settings`;
        settingsPanel.setAttribute('role', 'tabpanel');
        settingsPanel.setAttribute('aria-labelledby', `${popupId}-settings-tab`);
        settingsPanel.append(...Array.from(popup.childNodes));
        const metricPanel = document.createElement('div');
        metricPanel.id = `${popupId}-metrics`;
        metricPanel.setAttribute('role', 'tabpanel');
        metricPanel.setAttribute('aria-labelledby', `${popupId}-metrics-tab`);
        metricPanel.hidden = true;
        metricPanel.innerHTML = `<fieldset class="arz-chart-settings__metrics"><legend class="arz-chart-settings__sr-only">مقدار نمایشی</legend>${Object.keys(chart_metrics_1.COIN_CHART_METRICS).map((value) => `<label class="arz-chart-settings__metric"><input type="radio" name="${popupId}-metric" value="${value}" ${value === 'price' ? 'checked' : ''}><span>${chart_metrics_1.COIN_CHART_METRICS[value]}</span></label>`).join('')}</fieldset>`;
        const tabs = document.createElement('div');
        tabs.className = 'arz-chart-settings__tabs';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', 'تنظیمات نمودار');
        tabs.innerHTML = `<button type="button" role="tab" id="${popupId}-settings-tab" aria-controls="${settingsPanel.id}" aria-selected="true">تنظیمات نمودار</button><button type="button" role="tab" id="${popupId}-metrics-tab" aria-controls="${metricPanel.id}" aria-selected="false" tabindex="-1">مقدار نمایشی</button>`;
        const tabButtons = Array.from(tabs.querySelectorAll('button'));
        const panels = [settingsPanel, metricPanel];
        const selectTab = (index) => {
            tabButtons.forEach((tab, i) => {
                tab.setAttribute('aria-selected', String(i === index));
                tab.tabIndex = i === index ? 0 : -1;
                panels[i].hidden = i !== index;
            });
        };
        tabButtons.forEach((tab, index) => {
            tab.addEventListener('click', () => selectTab(index));
            tab.addEventListener('keydown', (event) => {
                if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key))
                    return;
                event.preventDefault();
                const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
                selectTab(next);
                tabButtons[next].focus();
            });
        });
        const hint = document.createElement('p');
        hint.className = 'arz-chart-settings__hint';
        hint.id = `${popupId}-hint`;
        hint.textContent = 'به‌روزرسانی زنده و انتخاب ارز فقط برای نمودار قیمت فعال است.';
        hint.hidden = true;
        settingsPanel.appendChild(hint);
        popup.append(tabs, settingsPanel, metricPanel);
        metricPanel.addEventListener('change', (event) => {
            const input = event.target;
            if (!input.checked)
                return;
            activeMetric = input.value;
            const isMetric = activeMetric !== 'price';
            const live = inputs.find((item) => item.dataset.chartSetting === 'livePrice');
            live.disabled = isMetric;
            live.checked = !isMetric && exports.chartSettings.get().livePrice;
            live.setAttribute('aria-describedby', hint.id);
            const currency = popup.querySelector('.arz-chart-settings__currency');
            currency.disabled = isMetric;
            currency.setAttribute('aria-describedby', hint.id);
            hint.hidden = !isMetric;
            if (screenshotButton)
                screenshotButton.disabled = isMetric;
            trigger.setAttribute('aria-label', `تنظیمات نمودار، ${chart_metrics_1.COIN_CHART_METRICS[activeMetric]}`);
            options.onMetricChange(activeMetric);
        });
    }
    const mobileDialog = options.onMetricChange ? document.createElement('dialog') : null;
    const mobileBackdrop = mobileDialog ? document.createElement('div') : null;
    if (mobileDialog && mobileBackdrop) {
        mobileDialog.className = 'arz-chart-settings-dialog';
        mobileDialog.setAttribute('aria-label', 'تنظیمات نمودار');
        mobileDialog.setAttribute('aria-modal', 'true');
        // Keep the existing dialog outside chart clipping/filter/stacking contexts.
        mobileBackdrop.className = 'arz-chart-settings-backdrop arz-chart-settings--metrics';
        mobileBackdrop.hidden = true;
        mobileBackdrop.appendChild(mobileDialog);
        document.body.appendChild(mobileBackdrop);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'arz-chart-settings__close';
        close.textContent = 'بستن';
        close.addEventListener('click', () => { closePopup(); trigger.focus(); });
        popup.prepend(close);
        mobileDialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            closePopup();
            trigger.focus();
        });
        mobileDialog.addEventListener('close', () => {
            // The close event is queued; a quick reopen must not be dismissed by it.
            if (!mobileDialog.hasAttribute('open'))
                closePopup();
        });
        mobileBackdrop.addEventListener('click', (event) => {
            if (event.target === mobileBackdrop) {
                closePopup();
                trigger.focus();
            }
        });
        mobileBackdrop.addEventListener('touchmove', (event) => {
            if (!mobileDialog.contains(event.target))
                event.preventDefault();
        }, { passive: false });
        mobileBackdrop.addEventListener('wheel', (event) => {
            if (!mobileDialog.contains(event.target))
                event.preventDefault();
        }, { passive: false });
        document.addEventListener('keydown', (event) => {
            if (!mobileDialog.hasAttribute('open') || event.key !== 'Tab')
                return;
            const focusable = Array.from(mobileDialog.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex="0"]')).filter((element) => element.getClientRects().length > 0);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (!first) {
                event.preventDefault();
                return;
            }
            if (!mobileDialog.contains(event.target)) {
                event.preventDefault();
                (event.shiftKey ? last : first).focus();
            }
            else if (event.shiftKey && event.target === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && event.target === last) {
                event.preventDefault();
                first.focus();
            }
        });
    }
    const usesMobilePopup = () => Boolean(mobileDialog && (document.body.classList.contains('mobile') || window.innerWidth <= 600));
    const positionMobileDialog = () => {
        if (!mobileBackdrop || !usesMobilePopup())
            return;
        const viewport = window.visualViewport;
        const width = (viewport === null || viewport === void 0 ? void 0 : viewport.width) || window.innerWidth;
        const height = (viewport === null || viewport === void 0 ? void 0 : viewport.height) || window.innerHeight;
        mobileBackdrop.style.left = `${(viewport === null || viewport === void 0 ? void 0 : viewport.offsetLeft) || 0}px`;
        mobileBackdrop.style.top = `${(viewport === null || viewport === void 0 ? void 0 : viewport.offsetTop) || 0}px`;
        mobileBackdrop.style.width = `${width}px`;
        mobileBackdrop.style.height = `${height}px`;
    };
    (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener('resize', positionMobileDialog);
    (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', positionMobileDialog);
    const closePopup = () => {
        popup.hidden = true;
        if ((mobileDialog === null || mobileDialog === void 0 ? void 0 : mobileDialog.open) && typeof mobileDialog.close === 'function')
            mobileDialog.close();
        else
            mobileDialog === null || mobileDialog === void 0 ? void 0 : mobileDialog.removeAttribute('open');
        if (mobileBackdrop)
            mobileBackdrop.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
    };
    const preparePopup = () => {
        const parent = usesMobilePopup() ? mobileDialog : control;
        if (popup.parentElement !== parent) {
            if (!popup.hidden)
                closePopup();
            parent.appendChild(popup);
        }
        positionMobileDialog();
    };
    window.addEventListener('resize', preparePopup, { passive: true });
    preparePopup();
    const positionControl = () => {
        const rangeButtons = Array.from(chartElement.querySelectorAll('.highcharts-range-selector-group .highcharts-button'));
        if (!rangeButtons.length)
            return;
        const buttonRects = rangeButtons.map((button) => button.getBoundingClientRect());
        const boxRect = chartBox.getBoundingClientRect();
        const groupRight = Math.max(...buttonRects.map((rect) => rect.right));
        const groupTop = Math.min(...buttonRects.map((rect) => rect.top));
        // Mobile rows reserve two slots after the range buttons (chart `mobileRangeTrailingSlots`):
        // settings and screenshot continue the buttons' pitch so the row is evenly distributed.
        const [settingsCenter, screenshotCenter] = screenshotButton && document.body.classList.contains('mobile')
            ? (0, chart_settings_1.getRangeRowTrailingCenters)(buttonRects, 2)
            : [];
        const desiredLeft = settingsCenter !== undefined
            ? settingsCenter - boxRect.left - trigger.offsetWidth / 2
            : groupRight - boxRect.left + 6;
        const left = Math.max(6, Math.min(desiredLeft, boxRect.width - 42));
        control.style.left = `${left}px`;
        // In the slot layout the (taller) icons are centred on the range buttons.
        const groupBottom = Math.max(...buttonRects.map((rect) => rect.bottom));
        const top = settingsCenter !== undefined
            ? (groupTop + groupBottom) / 2 - boxRect.top - trigger.offsetHeight / 2
            : groupTop - boxRect.top;
        control.style.top = `${Math.max(6, top)}px`;
        if (screenshotButton) {
            const offset = screenshotCenter !== undefined && left === desiredLeft ? screenshotCenter - settingsCenter : 0;
            // If the row cannot fit it, the screenshot button moves directly under the settings trigger.
            const below = left + (offset || trigger.offsetWidth + 10) + screenshotButton.offsetWidth > boxRect.width - 2;
            screenshotButton.style.left = offset && !below ? `${offset}px` : '';
            control.classList.toggle('arz-chart-settings--screenshot-below', below);
        }
    };
    exports.chartSettings.subscribe((settings) => {
        for (const input of inputs) {
            const name = input.dataset.chartSetting;
            input.checked = name === 'livePrice' && activeMetric !== 'price' ? false : settings[name];
        }
    });
    for (const input of inputs) {
        input.addEventListener('change', () => {
            exports.chartSettings.set(input.dataset.chartSetting, input.checked);
            if (input.dataset.chartSetting === 'livePrice')
                options.onLivePriceChange(input.checked);
            if (input.dataset.chartSetting === 'logarithmic')
                options.onLogarithmicChange(input.checked);
        });
    }
    for (const input of currencyInputs) {
        input.addEventListener('change', () => {
            if (!input.checked)
                return;
            options.onCurrencyChange(input.value === 'irt' ? 'irt' : 'usd');
        });
    }
    trigger.addEventListener('click', () => {
        preparePopup();
        const opening = popup.hidden;
        if (!opening) {
            closePopup();
            return;
        }
        popup.hidden = false;
        // show() preserves the dialog without making the whole coin page inert.
        if (usesMobilePopup()) {
            mobileBackdrop.hidden = false;
            if (typeof mobileDialog.show === 'function')
                mobileDialog.show();
            else
                mobileDialog.setAttribute('open', '');
        }
        trigger.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('pointerdown', (event) => {
        if (!control.contains(event.target) && !(mobileBackdrop === null || mobileBackdrop === void 0 ? void 0 : mobileBackdrop.contains(event.target)))
            closePopup();
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden) {
            closePopup();
            trigger.focus();
        }
    });
    // Chart mutations (tooltips, live prices, rebuilds) are frequent; measure once per frame, before paint.
    let positionFrame = 0;
    const schedulePositionControl = () => {
        if (positionFrame)
            return;
        positionFrame = requestAnimationFrame(() => {
            positionFrame = 0;
            positionControl();
        });
    };
    window.addEventListener('resize', schedulePositionControl, { passive: true });
    const observer = new MutationObserver(schedulePositionControl);
    observer.observe(chartElement, { childList: true, subtree: true });
    positionControl();
    options.onLivePriceChange(exports.chartSettings.get().livePrice);
    options.onLogarithmicChange(exports.chartSettings.get().logarithmic);
}
function mountChartSettingsWhenReady(chartElement, options) {
    const mount = () => {
        var _a;
        if ((_a = chartElement.closest('.arz-chart-loading-box')) === null || _a === void 0 ? void 0 : _a.querySelector('.arz-chart-settings'))
            return true;
        if (!(0, chart_settings_1.isChartSettingsReady)(Boolean(chartElement.querySelector('.highcharts-container')), chartElement.querySelectorAll('.highcharts-range-selector-group .highcharts-button').length))
            return false;
        createChartSettingsControl(chartElement, options);
        return true;
    };
    if (mount())
        return;
    const observer = new MutationObserver(() => {
        if (mount())
            observer.disconnect();
    });
    observer.observe(chartElement, { childList: true, subtree: true });
}
function readChartGeometry(chartElement, overlay) {
    var _a, _b, _c;
    const origin = overlay.getBoundingClientRect();
    const toOverlayRect = (rect) => ({
        left: rect.left - origin.left,
        top: rect.top - origin.top,
        right: rect.right - origin.left,
        bottom: rect.bottom - origin.top,
    });
    const isShown = (element) => {
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && !element.closest('[visibility="hidden"], .highcharts-tooltip');
    };
    const line = [];
    chartElement.querySelectorAll('.highcharts-series .highcharts-graph').forEach((path) => {
        const matrix = path.getScreenCTM();
        if (!matrix || !isShown(path))
            return;
        const length = path.getTotalLength();
        const step = Math.max(4, length / 400);
        for (let distance = 0; distance <= length; distance += step) {
            const { x, y } = path.getPointAtLength(distance);
            const point = new DOMPoint(x, y).matrixTransform(matrix);
            line.push({ x: point.x - origin.left, y: point.y - origin.top });
        }
    });
    const labelsOf = (selector) => Array.from(chartElement.querySelectorAll(selector))
        .filter(isShown)
        .map((element) => toOverlayRect(element.getBoundingClientRect()));
    // Keep comments inside the plot so they never cover the axis, range buttons or settings.
    const obstacles = labelsOf('.highcharts-label, .arz-chart-last-price-label, .highcharts-range-selector-group');
    (_a = chartElement.closest('.arz-chart-loading-box')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.arz-chart-settings, .arz-chart-screenshot').forEach((control) => {
        if (isShown(control))
            obstacles.push(toOverlayRect(control.getBoundingClientRect()));
    });
    const chart = (_c = (_b = window.Highcharts) === null || _b === void 0 ? void 0 : _b.charts) === null || _c === void 0 ? void 0 : _c.find((item) => item && chartElement.contains(item.renderTo));
    if (chart === null || chart === void 0 ? void 0 : chart.container) {
        const containerTop = chart.container.getBoundingClientRect().top - origin.top;
        const plotBottom = containerTop + chart.plotTop + chart.plotHeight;
        obstacles.push({ left: -1e4, top: plotBottom, right: 1e4, bottom: 1e4 });
    }
    return {
        line,
        obstacles,
        softObstacles: labelsOf('.highcharts-plot-line, .highcharts-yaxis-labels > *'),
    };
}
function startChartCommentOverlay(chartElement) {
    if (chartElement.dataset.chartCommentsInitialized === 'true')
        return;
    const channelId = chartElement.dataset.chartCommentsChannel;
    const chartBox = chartElement.closest('.arz-chart-loading-box');
    if (!channelId || !chartBox || !arzConstants.NEXUS_CHAT_BASEURL)
        return;
    chartElement.dataset.chartCommentsInitialized = 'true';
    const overlay = document.createElement('div');
    overlay.className = 'arz-chart-comments';
    overlay.setAttribute('aria-hidden', 'true');
    chartBox.appendChild(overlay);
    const activity = {
        documentHidden: document.hidden,
        chartVisible: false,
        pointerInside: false,
        pointerDown: false,
        selecting: false,
        tooltipVisible: false,
    };
    const seenIds = new Set();
    const queuedIds = new Set();
    const queue = [];
    let active = null;
    let lastPosition = null;
    let activeComment = null;
    let displayTimer;
    let chartReadyAt = null;
    let chartReadyObserver = null;
    let commentsEnabled = exports.chartSettings.get().comments;
    const consumerId = `coin-chart-${chartElement.id}`;
    const clearDisplayTimers = () => {
        window.clearTimeout(displayTimer);
    };
    const removeActive = () => {
        if (!active)
            return;
        active.classList.remove('is-visible');
        const item = active;
        active = null;
        activeComment = null;
        window.setTimeout(() => item.remove(), 180);
    };
    const renderComment = (comment) => {
        const cluster = document.createElement('div');
        cluster.className = `arz-chart-comment arz-chart-comment--${(0, chart_comments_1.getCommentLayout)(comment.text)}`;
        cluster.dir = 'ltr';
        const avatar = document.createElement('img');
        avatar.className = 'arz-chart-comment__avatar';
        avatar.src = comment.avatar;
        avatar.alt = comment.author;
        avatar.width = 32;
        avatar.height = 32;
        const message = document.createElement('span');
        message.className = 'arz-chart-comment__message';
        message.dir = 'auto';
        message.textContent = comment.text;
        const messageShell = document.createElement('span');
        messageShell.className = 'arz-chart-comment__message-shell';
        messageShell.appendChild(message);
        cluster.append(avatar, messageShell);
        for (const particle of (0, chart_comments_1.createReactionParticles)(comment.id, comment.reactions)) {
            const reaction = document.createElement('span');
            reaction.className = `arz-chart-comment__reaction arz-chart-comment__reaction--${particle.side}`;
            reaction.style.setProperty('--arz-reaction-offset', `${particle.offset}%`);
            reaction.style.opacity = String(particle.opacity);
            reaction.style.transitionDelay = `${particle.delay}ms`;
            reaction.style.setProperty('--arz-reaction-rotation', `${particle.rotation}deg`);
            if (particle.icon === 'cry') {
                const image = document.createElement('img');
                image.src = `${arzConstants.themeUrl}/assets/icons/cry.svg`;
                image.alt = '';
                reaction.appendChild(image);
            }
            else {
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
                use.setAttribute('href', `${arzConstants.themeUrl}/assets/icons/comments-reactions.svg?v2#${particle.icon}`);
                svg.appendChild(use);
                reaction.appendChild(svg);
            }
            messageShell.appendChild(reaction);
        }
        return cluster;
    };
    const scheduleNext = (delay = 1600) => {
        // While a comment is up, displayTimer is its removal timer, which schedules the next one.
        if (chartReadyAt === null || active)
            return;
        window.clearTimeout(displayTimer);
        const remainingInitialDelay = (0, chart_comments_1.getRemainingInitialDelay)(chartReadyAt, Date.now());
        displayTimer = window.setTimeout(showNext, Math.max(delay, remainingInitialDelay));
    };
    const showNext = () => {
        if (!commentsEnabled || active || (0, chart_comments_1.isPlaybackBlocked)(activity) || queue.length === 0) {
            if (activity.chartVisible && !activity.documentHidden) {
                scheduleNext(queue.length ? 1200 : 4000);
            }
            return;
        }
        const comment = queue.shift();
        if (!comment)
            return;
        queuedIds.delete(comment.id);
        seenIds.add(comment.id);
        activeComment = comment;
        active = renderComment(comment);
        overlay.appendChild(active);
        const safePosition = (0, chart_comments_1.chooseBubblePlacement)(Object.assign(Object.assign({}, readChartGeometry(chartElement, overlay)), { overlay: { width: overlay.clientWidth, height: overlay.clientHeight }, bubble: { width: active.offsetWidth, height: active.offsetHeight }, preferred: (0, chart_comments_1.createBubblePosition)(comment.id), previous: lastPosition, inset: 20 }));
        lastPosition = safePosition;
        active.style.left = `${safePosition.x}px`;
        active.style.top = `${safePosition.y}px`;
        window.requestAnimationFrame(() => active === null || active === void 0 ? void 0 : active.classList.add('is-visible'));
        displayTimer = window.setTimeout(() => {
            removeActive();
            scheduleNext(4200 + Math.round(Math.random() * 2600));
        }, (0, chart_comments_1.getCommentStandingTime)(comment.text));
    };
    const stopForInteraction = () => {
        clearDisplayTimers();
        (0, chart_comments_1.skipInterruptedChartComment)(activeComment, seenIds, queuedIds);
        removeActive();
    };
    const resumeAfterInteraction = (event) => {
        (0, chart_comments_1.releaseChartInteraction)(activity, event === null || event === void 0 ? void 0 : event.pointerType);
        if (activity.chartVisible && !activity.documentHidden)
            scheduleNext((0, chart_comments_1.getInteractionResumeDelay)());
    };
    const enqueueMessages = (messages) => {
        const comments = (0, chart_comments_1.selectEligibleChartComments)(messages, Date.now(), seenIds);
        for (const comment of comments) {
            if (queuedIds.has(comment.id))
                continue;
            queuedIds.add(comment.id);
            queue.push(comment);
        }
    };
    const setChartVisibility = (visible) => {
        var _a;
        const isVisible = visible && !document.hidden;
        activity.chartVisible = isVisible;
        channelMessages.setDemand(channelId, consumerId, isVisible && commentsEnabled);
        if (!isVisible) {
            stopForInteraction();
            return;
        }
        enqueueMessages((_a = channelMessages.peek(channelId).latest) === null || _a === void 0 ? void 0 : _a.data);
        scheduleNext(1500);
    };
    channelMessages.subscribe(channelId, (body) => {
        enqueueMessages(body === null || body === void 0 ? void 0 : body.data);
        if (activity.chartVisible && chartReadyAt !== null)
            scheduleNext(1200);
    });
    exports.chartSettings.subscribe((settings) => {
        var _a;
        commentsEnabled = settings.comments;
        overlay.hidden = !commentsEnabled;
        channelMessages.setDemand(channelId, consumerId, activity.chartVisible && commentsEnabled);
        if (!commentsEnabled) {
            clearDisplayTimers();
            removeActive();
            return;
        }
        enqueueMessages((_a = channelMessages.peek(channelId).latest) === null || _a === void 0 ? void 0 : _a.data);
        if (activity.chartVisible && chartReadyAt !== null)
            scheduleNext(0);
    });
    const updateChartVisibility = () => {
        const rect = chartElement.getBoundingClientRect();
        setChartVisibility(rect.bottom > 0 && rect.top < window.innerHeight);
    };
    if (typeof window.IntersectionObserver === 'function') {
        const chartVisibilityObserver = new IntersectionObserver((entries) => {
            var _a;
            setChartVisibility(Boolean((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting));
        }, { threshold: 0.01 });
        chartVisibilityObserver.observe(chartElement);
    }
    else {
        window.addEventListener('scroll', updateChartVisibility, { passive: true });
        window.addEventListener('resize', updateChartVisibility, { passive: true });
    }
    updateChartVisibility();
    const beginPlaybackWhenChartIsReady = () => {
        const markChartReady = () => {
            var _a;
            const hasRenderedChart = Boolean(chartElement.querySelector('.highcharts-container'));
            if (!hasRenderedChart || chartElement.classList.contains('arz-chart-loading'))
                return;
            chartReadyAt = Date.now();
            chartReadyObserver === null || chartReadyObserver === void 0 ? void 0 : chartReadyObserver.disconnect();
            chartReadyObserver = null;
            (0, chart_comments_1.scheduleInitialChannelMessagesRequest)(() => commentsEnabled && channelMessages.request(channelId), (callback, delay) => window.setTimeout(callback, delay));
            enqueueMessages((_a = channelMessages.peek(channelId).latest) === null || _a === void 0 ? void 0 : _a.data);
            scheduleNext(0);
        };
        markChartReady();
        if (chartReadyAt !== null)
            return;
        chartReadyObserver = new MutationObserver(markChartReady);
        chartReadyObserver.observe(chartElement, {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true,
        });
    };
    chartElement.addEventListener('pointerenter', () => {
        activity.pointerInside = true;
        stopForInteraction();
    }, { passive: true });
    chartElement.addEventListener('pointerleave', () => {
        activity.pointerInside = false;
        resumeAfterInteraction();
    }, { passive: true });
    chartElement.addEventListener('pointerdown', () => {
        activity.pointerDown = true;
        stopForInteraction();
    }, { passive: true });
    chartElement.addEventListener('pointermove', () => {
        if (activity.pointerDown)
            activity.selecting = true;
    }, { passive: true });
    window.addEventListener('pointerup', resumeAfterInteraction, { capture: true, passive: true });
    window.addEventListener('pointercancel', resumeAfterInteraction, { capture: true, passive: true });
    document.addEventListener('visibilitychange', () => {
        activity.documentHidden = document.hidden;
        updateChartVisibility();
    });
    beginPlaybackWhenChartIsReady();
}
